import {
  currencyFormatterWithDecimals,
  truncateText,
  timeDifferenceInYears,
  roundOfNumber,
} from './numericalHelper';

describe('Currency Format Helper', () => {
  test('currency Formatter With Decimals', () => {
    expect(currencyFormatterWithDecimals(150.652, 2)).toEqual('150.65');
  });

  test('currency Formatter With no Decimals', () => {
    expect(currencyFormatterWithDecimals(150.652)).toEqual('151');
  });

  test('truncate text', () => {
    expect(truncateText('This is a sample text', 10)).toEqual('This is a ..');
  });

  test('truncate text with 0 length', () => {
    expect(truncateText('This is a sample text', 0)).toEqual(
      'This is a sample text',
    );
  });

  test('round of number', () => {
    expect(roundOfNumber(145.45, 1)).toEqual(145.4);
  });

  test('round of number with nothing to round', () => {
    expect(roundOfNumber(1456, 1)).toEqual(1456);
  });

  test('time difference in years', () => {
    expect(timeDifferenceInYears('05-16-2019', '05-15-2019')).toEqual(0);
  });
});
